export default class OnPageNav extends HTMLElement {

    get verticalOffset() {
        if (this.width < 768) {
            return document.querySelector("#global-header").clientHeight + this.querySelector(".anchor-links-wrapper").clientHeight;
        }
        return document.querySelector("#global-header").clientHeight;
    }

    get preventUpdatingOfActiveMenu() {
        return this._preventUpdatingOfActiveMenu;
    }

    set preventUpdatingOfActiveMenu(value) {
        this._preventUpdatingOfActiveMenu = value;
        if (this._preventUpdatingOfActiveMenuTimer) {
            window.clearTimeout(this._preventUpdatingOfActiveMenuTimer);
        }
        if (value) {
            this._preventUpdatingOfActiveMenuTimer = setTimeout(() => {
                this._preventUpdatingOfActiveMenu = false;
                this._preventUpdatingOfActiveMenuTimer = null;
            }, 800);
        }
    }

    connectedCallback() {

        this.debug = true;

        this.log("OnPageNav connected " + this.classList);

        this._preventUpdatingOfActiveMenu = false;

        this.initialize(this.getAnchor(document.URL));

    }

    initialize(startAnchor) {

        this.width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

        this.navWrapper = this.querySelector(".anchor-links-wrapper");
        this.navWrapper.scrollLeft = 0;

        this.anchors = [];
        var _this = this;
        this.querySelectorAll(".nav-link").forEach(item => {
            var id = _this.getAnchor(item.href);
            _this.anchors[id] = {
                id: id,
                menuItem: item,
                anchorItem: document.getElementById(id)
            };
        });

        this.log(this.navWrapper);
        this.log(this.anchors);

        document.addEventListener("scroll", (e) =>  this.documentScrollHandler(this, e));

        for (var key in this.anchors) {
            var item = this.anchors[key];
            item.menuItem.addEventListener("click", (e) => this.menuClickHandler(e));
        }

        this.activeItem = this.anchors[startAnchor];
        if (this.activeItem) {
            this.setActive(this.activeItem);
            this.vScrollTo(this.activeItem.anchorItem, window, this.verticalOffset);
        } else {
            this.documentScrollHandler(this);
        }

    }

    documentScrollHandler(_this, e) {
        if (!this.preventUpdatingOfActiveMenu) {
            _this.log("OnPageNav::scroll")

            var found = false;
            var item;
            for (var key in _this.anchors) {
                item = _this.anchors[key];
                if (!found && (_this.isElementInViewport(item.anchorItem))) {
                    found = true;
                    _this.setActive(item);
                } else {
                    _this.clearActive(item);
                }
            }
            if (!found && item) {
                _this.setActive(item);
            }
        }
    }

    menuClickHandler(e) {
        e.preventDefault();
        var anchor = this.anchors[this.getAnchor(e.target.href)];
        if (anchor) {
            this.clearActive();
            this.setActive(anchor);
            this.vScrollTo(anchor.anchorItem, window, this.verticalOffset);
        }
        return false;
    }

    isElementInViewport(el) {
        var rect = el.getBoundingClientRect();
        return (
            rect.top >= document.querySelector("#global-header").clientHeight
        );
    }

    getAnchor(url) {
        var urlParts = url.split('#');
        return (urlParts.length > 1) ? decodeURI(urlParts[1]) : null;
    }

    setActive(item) {
        item.menuItem.classList.add("active");
        if (this.width < 768) {
            this.hScrollTo(item.menuItem);
        }
    }

    clearActive(item) {
        if (item) {
            item.menuItem.classList.remove("active");
        } else {
            for (var key in this.anchors) {
                var item = this.anchors[key];
                item.menuItem.classList.remove("active");
            }
        }
    }

    vScrollTo(el, container = window, offset = 0) {
        this.preventUpdatingOfActiveMenu = true;
        this.log(offset);
        container.scroll({
            top: el.offsetTop - offset,
            left: 0,
            behavior: 'smooth'
        });
    }

    hScrollTo(el, container = el.parentNode, offset = 0) {
        container.scroll({
            top:0,
            left: el.offsetLeft + offset,
            behavior: 'smooth'
        });
    }

    log(message) {
        if (this.debug) {
            console.log(message);
        }
    }
}

customElements.define('on-page-nav', OnPageNav, { extends: 'nav' });